<template>
  <div class="article">
    <p class="article-title">{{$t('article17.title')}}</p>
    <p class="article-content" style="font-size:12px;text-align:center;">{{$t('article17.p1')}}</p>
    <p class="article-content">{{$t('article17.p2')}}</p>
    <p class="article-content">{{$t('article17.p3')}}</p>
    <img src="../../../assets/article/17-2.jpg" />
    <p class="article-content" style="font-size:12px;text-align:center;">{{$t('article17.p4')}}</p>
    <p
      class="article-content"
      style="font-weight:bold;margin-top:40px;font-size:18px;"
    >{{$t('article17.p5')}}</p>
    <p class="article-content">{{$t('article17.p6')}}</p>
    <p class="article-content">{{$t('article17.p7')}}</p>
    <p class="article-content">{{$t('article17.p8')}}</p>
    <img src="../../../assets/article/17-1.png" />
    <p class="article-content" style="font-size:12px;text-align:center;">{{$t('article17.p26')}}</p>
    <p
      class="article-content"
      style="font-weight:bold;margin-top:40px;font-size:18px;"
    >{{$t('article17.p9')}}</p>
    <p class="article-content">{{$t('article17.p10')}}</p>
    <img :src="articleImg173" />
    <p class="article-content" style="font-size:12px;text-align:center;">{{$t('article17.p11')}}</p>
    <p class="article-content">{{$t('article17.p12')}}</p>
    <ul style="margin-left:20px;">
      <li>
        <p class="article-content">{{$t('article17.p13')}}</p>
      </li>
      <li>
        <p class="article-content">{{$t('article17.p14')}}</p>
      </li>
      <li>
        <p class="article-content">{{$t('article17.p15')}}</p>
      </li>
    </ul>
    <p
      class="article-content"
      style="font-weight:bold;margin-top:40px;font-size:18px;"
    >{{$t('article17.p16')}}</p>
    <p class="article-content">{{$t('article17.p17')}}</p>
    <img :src="articleImg174" />
    <p class="article-content" style="font-size:12px;text-align:center;">{{$t('article17.p18')}}</p>
    <p class="article-content">{{$t('article17.p19')}}</p>
    <p
      class="article-content"
      style="font-weight:bold;margin-top:40px;font-size:18px;"
    >{{$t('article17.p20')}}</p>
    <p class="article-content">{{$t('article17.p21')}}</p>
    <p class="article-content">{{$t('article17.p22')}}</p>
    <img :src="articleImg175" />
    <p class="article-content" style="font-size:12px;text-align:center;">{{$t('article17.p23')}}</p>
    <p class="article-content">
      {{$t('article17.p24')}}
      <a
        href="https://www.redteamobile.com/CaaS"
        target="blank"
        style="color:#cf2a2a"
      >www.redteamobile.com</a>
    </p>
    <p class="article-content">
      <a
        href="https://www.facebook.com/hashtag/taiwanesimpenetration?source=note&epa=HASHTAG"
        target="blank"
      >{{$t('article17.p25')}}</a>
    </p>
  </div>
</template>
<script>
export default {
  computed: {
    articleImg173() {
      return this.$store.state.articleImg173
    },
    articleImg174() {
      return this.$store.state.articleImg174
    },
    articleImg175() {
      return this.$store.state.articleImg175
    }
  }
}
</script>
